import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Language } from 'src/interface';
import { LANGUAGE } from 'src/constants';
import { setLocalStorageItem } from 'src/helper';

export const useLanguage = () => {
  const { i18n, t } = useTranslation('general');

  const td = useCallback(
    (
      key?: string,
      options?: Record<string, string | number | undefined>,
    ): string => {
      if (!key) {
        return '';
      }
      const result = t(key, 'unknown-key', options);
      return result === 'unknown-key' ? key : (result as string);
    },
    [t],
  );

  const langList = useMemo(() => {
    return i18n.language === Language.RU
      ? [Language.RU, Language.EN]
      : [Language.EN, Language.RU];
  }, [i18n.language]);

  const setLang = useCallback(
    (lang: Language) => {
      i18n.changeLanguage(lang);
      setLocalStorageItem(LANGUAGE, lang);
    },
    [i18n],
  );

  return {
    currentLang: i18n.language as Language,
    langList,
    setLang,
    t,
    td,
  };
};
